// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2DIDF","inputDescription":"styles_inputDescription__1R3Qm"};